import { 	CHECK_PASSWORD_LINK_VALID
				} from '../actions/types';

export default function (state=false, action) {
	switch (action.type) {
		case CHECK_PASSWORD_LINK_VALID:
			console.log(CHECK_PASSWORD_LINK_VALID);
			console.log(action.payload);
			return action.payload;
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/lostPasswordReducer.js